<template>
  <div class="modal modal-earned-commissions" :class="{ 'show': showModal }">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Total Earnings for {{ formattedPeriod(month, year, true) }}</h5>
          <button type="button" class="close" @click="showModal = false">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="table-responsive">
            <table class="table closed-students-table mb-0">
              <thead>
              <tr class="bg-white">
                <th scope="col" class="text-center">No</th>
                <th scope="col" class="text-center">Type</th>
                <th scope="col">Student</th>
                <th scope="col">Course</th>
                <th scope="col">Tuition</th>
                <th scope="col">Commissions</th>
                <th scope="col" class="text-nowrap">Student Qty</th>
                <th scope="col" class="text-nowrap">Key Partner</th>
                <th scope="col">Referer/Hunter</th>
                <th scope="col">Total</th>
              </tr>
              </thead>
              <tbody>
              <template v-for="(group, groupIndex) in commissions">
                <tr v-if="group.students.length > 0" :key="`${groupIndex}-${group.students[0].student.id}`" class="has-coe">
                  <td :rowspan="group.count" class="text-center">{{ groupIndex + 1 }}</td>
                  <td :rowspan="group.count" class="text-center">{{ getStudentType(group.students[0].type) }}</td>
                  <td class="student-name" :title="group.students[0].student.full_name" :rowspan="group.count" >
                    <a :href="group.students[0].student.url">{{ truncatedName(group.students[0].student.full_name) }}</a>
                  </td>
                  <td :title="group.students[0].course">{{ truncatedName(group.students[0].course) }}</td>
                  <td>{{ formattedNumbers(group.students[0].tuition_fee) }}</td>
                  <td>{{ formattedNumbers(group.students[0].commission) }}</td>
                  <td>{{ getQtyPercentage(group.students[0].qty_percentage) }}</td>
                  <td>{{ getEnhancerPercentage(group.students[0].enhancers, ['key_partner', 'level']) }}</td>
                  <td>{{ getEnhancerPercentage(group.students[0].enhancers, ['referer', 'hunter', 'self']) }}</td>
                  <td>{{ formattedNumbers(group.students[0].total) }}</td>
                </tr>
                <!-- Additional rows within the group (if any) -->
                <tr v-for="(student, studentIndex) in group.students.slice(1)" :key="`${groupIndex}-${student.student.id}-${studentIndex}`" class="has-coe">
                  <td :title="student.course">{{ truncatedName(student.course) }}</td>
                  <td>{{ formattedNumbers(student.tuition_fee) }}</td>
                  <td>{{ formattedNumbers(student.commission) }}</td>
                  <td>{{ getQtyPercentage(student.qty_percentage) }}</td>
                  <td>{{ getEnhancerPercentage(student.enhancers, ['key_partner', 'level']) }}</td>
                  <td>{{ getEnhancerPercentage(student.enhancers, ['referer', 'hunter', 'self']) }}</td>
                  <td>{{ formattedNumbers(student.total) }}</td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatCurrency, formatPeriod, truncateText } from "../../../utils/helpers";

import '../../../../sass/commissions/earned-commissions-modal.scss';

export default {
  name: 'EarnedCommissionsModal',
  props: {
    isAccepted: {
      type: Boolean,
      default: false
    },
    month: {
      type: Number,
      default: 0
    },
    year: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      showModal: false,
      commissions: []
    };
  },
  methods: {
    formattedNumbers(number) {
      return formatCurrency(number);
    },
    formattedPeriod(month, year, mode = false) {
      return formatPeriod(month, year, mode);
    },
    truncatedName(name, limit = 20) {
      return truncateText(name, limit);
    },
    getQtyPercentage(student_qty) {
      return student_qty ? `${student_qty.percentage}%` : '-';
    },
    getEnhancerPercentage(enhancers, types) {
      const enhancer = enhancers.find(enh => types.includes(enh.type));
      return enhancer ? `${enhancer.percentage}%` : '-';
    },
    getTotal(metric, statuses = []) {
      return this.students.reduce((sum, student) => {
        if (statuses.length === 0 || statuses.includes(student.status)) {
          return sum + (parseFloat(student[metric]) || 0);
        }
        return sum;
      }, 0).toFixed(2);
    },
    getStudentType(type) {
      switch (type) {
        case 'commission':
          return 'COE/LOA';
        case 'closed':
          return 'No COE/LOA';
        default:
          return 'Prevision';
      }
    }
  }
};
</script>